module.exports = __webpack_public_path__ + "static/media/logo-icon.e0a74957.png";